var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('navbar'),_c('app-main'),_c('root')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }